exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.turnstile-container[data-v-026506a3] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 100%;\n}", "", {"version":3,"sources":["D:/WorkProjects-git/MultCloud/Project/mcFrontend/src/components/popup/share_page_popups/forget_pwd_popup.vue"],"names":[],"mappings":";AAAA;EACE,qBAAc;EAAd,qBAAc;EAAd,cAAc;EACd,yBAAwB;MAAxB,sBAAwB;UAAxB,wBAAwB;EACxB,YAAY;CACb","file":"forget_pwd_popup.vue","sourcesContent":[".turnstile-container {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":true,"importLoaders":2}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-026506a3","scoped":true,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":54}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/popup/share_page_popups/forget_pwd_popup.vue
// module id = mGYe
// module chunks = 2